// extracted by mini-css-extract-plugin
module.exports = {"touch":"Touch_touch__3fQFS","touch__preview":"Touch_touch__preview__3alBT"};